import { Dispatch, useContext, useEffect, useReducer, useState } from 'react';
import { ExhibitorContext } from '../initialLizeContext';
import exhibitorReducer from '../../Reducers/AuthReducer/ExhibitorReducer';
import { parseCookies } from 'nookies';
import { httpService } from '../../Helpers/Fetcher/axios';
import {
  B2B_USER_FAILED,
  B2B_USER_SUCCESS,
  EXHIBITOR_USER_FAILED,
  EXHIBITOR_USER_SUCCESS,
} from '../../Helpers/Constant';

export type ExhibitorContextType = {
  state: TExhibitorData;
  dispatch: Dispatch<any>; // Replace 'any' with a more specific action type if available
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
};
export type ExhibitorType = {
  user_fair_member_id: string | null;
  user_fair_member_email: string | null;
  user_fair_member_company_email: string | null;
  user_fair_member_contact_name: string | null;
  user_fair_member_contact_designation: string | null;
  user_fair_member_contact_number: string | null;
  user_fair_member_contact_email: string | null;
  user_fair_member_company_id: string | null;
  user_fair_member_company_name: string | null;
  user_fair_member_company_address: string | null;
  user_fair_member_company_city: string | null;
  user_fair_member_company_zip: string | null;
  user_fair_member_company_website: string | null;
  user_fair_member_company_telephone: string | null;
  user_fair_member_company_logo: string | null;
  user_fair_member_company_logo_ai: string | null;
  user_fair_member_status: string | null;
};
export type TExhibitorData = {
  exhibitorUser: ExhibitorType & {
    token: string | null;
  };
  isLoading: boolean;
};
const initialState: TExhibitorData = {
  exhibitorUser: {
    user_fair_member_id: null,
    user_fair_member_email: null,
    user_fair_member_company_email: null,
    user_fair_member_contact_name: null,
    user_fair_member_contact_designation: null,
    user_fair_member_contact_number: null,
    user_fair_member_contact_email: null,
    user_fair_member_company_id: null,
    user_fair_member_company_name: null,
    user_fair_member_company_address: null,
    user_fair_member_company_city: null,
    user_fair_member_company_zip: null,
    user_fair_member_company_website: null,
    user_fair_member_company_telephone: null,
    user_fair_member_company_logo: null,
    user_fair_member_company_logo_ai: null,
    user_fair_member_status: null,
    token: null,
  },
  isLoading: false,
};
const ExhibitorContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [state, dispatch] = useReducer(exhibitorReducer, initialState);
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    (async () => {
      const toab_exibitor_token = localStorage.getItem('toab_exibitor_token');
      // const { toab_fair } = parseCookies();
      if (toab_exibitor_token) {
        setIsLoading(true);
        try {
          //this istoken verify is not verified throw error this error is not need i need axios error so this line code are commented
          // const { payload } = await jose.jwtVerify(
          //   toab_exibitor_token,
          //   new TextEncoder().encode('FaTO5b$eCzw!Ukw8^d*UUf*JABbeIrR')
          // );

          // when reload   this api is call and get data(if token is valid) if not valid token get error and  b2bContext data will clear
          const { data } = await httpService.get<ExhibitorType>({
            url: `/api/auth/fair-member/profile`,
          });
          dispatch({
            type: EXHIBITOR_USER_SUCCESS,
            payload: { ...data, token: toab_exibitor_token },
          });
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          dispatch({ type: EXHIBITOR_USER_FAILED });
        }
      } else {
        setIsLoading(false);
        dispatch({ type: EXHIBITOR_USER_FAILED });
      }
    })();
  }, []);
  return (
    <ExhibitorContext.Provider
      value={{ state, dispatch, isLoading, setIsLoading }}
    >
      {children}
    </ExhibitorContext.Provider>
  );
};

const useExhibitorAuthContext = () => {
  const context = useContext(ExhibitorContext);
  return context as ExhibitorContextType;
};

export { ExhibitorContextProvider, useExhibitorAuthContext };
